export interface SharedState {
  filterCount: number;
}

export const initialSharedState: SharedState = {
  filterCount: 0,
};
